import { useEffect, useState } from 'react';
import { getAuthStorage } from 'domains/Auth/authService/authService';

const DEFAULT_TIMEZONE = 'UTC';
export const useTimezone = () => {
  const [timezone, setTimezone] = useState<string>(DEFAULT_TIMEZONE);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const authData = await getAuthStorage();
        const userTimezone = authData?.timezone || DEFAULT_TIMEZONE;
        if (isMounted) setTimezone(userTimezone);
      } catch (error) {
        console.error('Error getting timezone:', error);
        if (isMounted) setTimezone(DEFAULT_TIMEZONE);
      } finally {
        if (isMounted) setIsLoading(false);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, []);

  return { timezone, isLoading };
};
